
import api from './api'
import { useDownload } from '@/helpers/download'

export default {

    getXlsx(params = {}) {

        return new Promise((resolve, reject) => {

            api.post('/catalog/file', null, { params: params })
                .then( response => {
                    if ( response.status === 204 ) {
                        reject('Aucun fichier à télécharger') 
                    }

                    useDownload(response.headers.location)
                        .then(() => resolve() )
                })
                .catch(() => reject())
        }) 
    },

    count(params = {}) {

        return api.get('/catalog', { params })
            .then( response => parseInt(response.headers['x-pagination-count']) )
    },

    list(params = {}) {

        return api.get('/catalog', { params })
            .then( json => json.data )
            
    },

    search(params = {}) {

        return api.get('/catalog', { params })
            .then( json => json.data )            
    } 
}
